import React from 'react'
import PropTypes from 'prop-types'
import Line from '!!@svgr/webpack!../../../assets/media/happy-line.svg'
import classNames from 'classnames'

export default function HappyLine({ color = 'Bg', className = '', ...props }) {
  // List static text classes to avoid purging them
  const colorClass = {
    Bg: 'text-Bg',
    BgSub: 'text-BgSub',
    white: 'text-white',
    'beige-lightest': 'text-beige-lightest',
    black: 'text-black',
  }[color]

  return (
    <Line
      className={classNames('block fill-current', colorClass, className)}
      {...props}
    />
  )
}

HappyLine.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
}
